import { render, staticRenderFns } from "./BookingSummarySectionFour.vue?vue&type=template&id=3b5996d8&"
import script from "./BookingSummarySectionFour.vue?vue&type=script&lang=js&"
export * from "./BookingSummarySectionFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports